import { render, staticRenderFns } from "./SchedulesTabs.vue?vue&type=template&id=0cfa725b&"
import script from "./SchedulesTabs.vue?vue&type=script&lang=ts&"
export * from "./SchedulesTabs.vue?vue&type=script&lang=ts&"
import style0 from "./SchedulesTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports